import jwtDecode from "jwt-decode";
import http from "./httpService";

const apiEndpointAuth = "auth";
const apiEndpointUser = "users";
const accessTokenKey = "token";
const refreshTokenKey = "rtoken";

http.setJwt(getJwt());

export async function login(username, password) {
  const { data: { access_token: jwt, refresh_token: rjwt } } = 
    await http.post(apiEndpointAuth, { username, password });
  storeTokens(jwt, rjwt);
}

export function loginWithJwt(jwt) {
  localStorage.setItem(accessTokenKey, jwt);
}

export function logout() {
  localStorage.removeItem(accessTokenKey);
  localStorage.removeItem(refreshTokenKey);
}

// NOTE: If token is local, just return user. If
// token is third party, get the user from API
export async function getCurrentUser() {
  try {
    const jwt = localStorage.getItem(accessTokenKey),
          decoded_token = jwtDecode(jwt),
          issuer = decoded_token['iss'];
    const rjwt = localStorage.getItem(refreshTokenKey),
          decoded_rtoken = jwtDecode(rjwt),
          expiry = decoded_rtoken['exp'];
    const current_time = new Date().getTime() / 1000;

    if (current_time > expiry) {
      return null;
    }
    else {
      if (issuer !== "creaption") {
        const issuer_user_id = decoded_token['sub'];
        const { data } = await http.get(apiEndpointUser, { params: 
                          { 
                            provider: issuer,
                            provider_user_id: issuer_user_id
                          }});
        return data["users"];
      }
      else {
        return decoded_token.sub;
      }
    }
  } catch (ex) {
    return null;
  }
}

export function getJwt() {
  return localStorage.getItem(accessTokenKey);
}

export function storeTokens(accessToken, refreshToken) {
  localStorage.setItem(accessTokenKey, accessToken);
  localStorage.setItem(refreshTokenKey, refreshToken);  
}

export function storeAccessToken(accessToken) {
  localStorage.setItem(accessTokenKey, accessToken);
}

export function storeRefreshToken(refreshToken) {
  localStorage.setItem(refreshTokenKey, refreshToken);  
}

export default {
  login,
  loginWithJwt,
  logout,
  getCurrentUser,
  getJwt,
  storeTokens,
  storeAccessToken,
  storeRefreshToken
};
